import image1 from "./images/seeds_1.png";
import image2 from "./images/soybeans_grains.png";
import image3 from "./images/rice_grains.png";
import image4 from "./images/sesame_seed2.png";
import image5 from "./images/cashew-1.png";
import image6 from "./images/gold_diamond_4.png";
import image7 from "./images/white_sugar_1.png";
import image8 from "./images/frytol_1.png";
import image9 from "./images/coach.png";
import category_img1 from "./images/categories/azobe_wood_1.jpg";
import category_img2 from "./images/categories/grains_seeds_2.jpg";
import category_img3 from "./images/categories/scrap.jpg";
import category_img4 from "./images/categories/goldbar_2.jpg";
import product_img1 from "./images/products/soybeans_grains.png";
import product_img2 from "./images/products/cashew-1.png";
import product_img3 from "./images/products/sesame_seed2.png";
import product_img4 from "./images/products/white_sugar_1.png";
import product_img5 from "./images/products/denya_wood_1.png";
import product_img6 from "./images/products/vegetable_oil.png";
import product_img7 from "./images/products/azobe_wood.png";
import product_img8 from "./images/products/teak_wood.png";
import product_img9 from "./images/products/scrap.png";
import product_img10 from "./images/products/gold_diamond_4.png";
import member_of from "./images/payment/memberof.png";

// TRAVEL AND TOUR IMAGE IMPORTS
// import polynesia from "./images/travel/polynesia.jpg";
// import panorama from "./images/travel/panorama.jpg";
// import bora_bora from "./images/travel/bora_bora.jpg";
import lady_visa from "./images/travel/lady_visa.jpg";
import zanzibar from "./images/travel/zanzibar.jpg";
import kid_passport from "./images/travel/kid_passport.jpg";
import airplane from "./images/travel/airplane.jpg";

// TRAVEL AND TOUR ABOUT US PAGE
import cartoon_tree_no_bg from "./images/travel/about/cartoon_tree_no_bg.png";
import smile_black_lady from "./images/travel/about/smile_black_lady.jpg";
import white_traveling_lady from "./images/travel/about/traveling_white_lady.jpg";

// GALLERY PAGE IMAGES
import gallery_video_1 from "./images/media/vid-01.mp4";
import gallery_video_2 from "./images/media/vid-02.mp4";
import gallery_image_1 from "./images/media/img-01.jpg";
import gallery_image_2 from "./images/media/img-02.jpg";
import gallery_image_3 from "./images/media/img-03.jpg";
import gallery_image_4 from "./images/media/img-04.jpg";
import gallery_video_3 from "./images/media/vid-03.mp4";
import gallery_video_4 from "./images/media/vid-04.mp4";
import gallery_video_5 from "./images/media/vid-05.mp4";
import gallery_video_6 from "./images/media/vid-06.mp4";
import gallery_image_5 from "./images/media/img-05.jpg";
import gallery_video_7 from "./images/media/vid-07.mp4";
import gallery_video_8 from "./images/media/vid-08.mp4";
import gallery_video_9 from "./images/media/vid-09.mp4";

// MAIN PAGE IMAGES
export const sliderItems = [
  {
    id: 1,
    img: image1,
    title: "GRAINS & SEEDS",
    desc: "WE ARE A LEADING MANUFACTURER AND EXPORTER OF SEEDS LIKE...",
    // bg: "fbf0f4"
    show_site: false,
    bg: "f5fafd",
  },
  {
    id: 2,
    img: image2,
    title: "SOYABEANS",
    desc: "WE MANUFACTURE AND EXPORT SOYABEANS",
    // bg: "fcf1ed",
    bg: "f5fafd",
    show_site: false,
  },
  {
    id: 3,
    img: image3,
    title: "RICE",
    desc: "WE MANUFACTURE AND EXPORT RICE",
    bg: "f5fafd",
    show_site: false,
  },
  {
    id: 4,
    img: image4,
    title: "SESAME SEEDS",
    desc: "WE MANUFACTURE AND EXPORT SESAME SEEDS",
    bg: "f5fafd",
    show_site: false,
  },
  {
    id: 5,
    img: image5,
    title: "CASHEW NUTS",
    desc: "WE MANUFACTURE AND EXPORT CASHEW NUTS",
    bg: "f5fafd",
    show_site: false,
  },
  {
    id: 6,
    img: image6,
    title: "NATURAL MINERALS",
    desc: "WE ALSO EXPORT NATURAL MINERALS LIKE GOLD AND DIAMONDS",
    bg: "f5fafd",
    show_site: false,
  },
  {
    id: 7,
    img: image7,
    title: "SUGAR",
    desc: "WE ALSO SELL/EXPORT SUGAR",
    bg: "f5fafd",
    show_site: false,
  },
  {
    id: 8,
    img: image8,
    title: "OIL",
    desc: "WE ALSO SELL/EXPORT COOKING OIL",
    bg: "f5fafd",
    show_site: false,
  },
  {
    id: 9,
    img: image9,
    title: "TRAVEL AND TOURS",
    desc: "GO TO OUR TRAVEL AND TOUR PAGE TO VIEW MORE",
    bg: "f5fafd",
    show_site: true,
  },
];

export const categories = [
  {
    id: 1,
    img: category_img1,
    title: "WOOD PRODUCTS",
  },
  {
    id: 2,
    img: category_img2,
    title: "GRAINS AND OTHER FOOD PRODUCTS",
  },
  {
    id: 3,
    img: category_img3,
    title: "SCRAPS",
  },
  {
    id: 4,
    img: category_img4,
    title: "NATURAL MINERALS",
  },
];

export const popularProducts = [
  {
    id: 1,
    img: product_img1,
    title: "SOYABEANS",
    desc: "We get it from individual farmers export/sell to organizations",
  },
  {
    id: 2,
    img: product_img2,
    title: "CASHEW NUTS",
    desc: "We are into export of cashews",
  },
  {
    id: 3,
    img: product_img3,
    title: "SESAME SEEDS",
    desc: "We get it from individual farmers export/sell to organizations",
  },
  {
    id: 4,
    img: product_img4,
    title: "SUGAR",
    desc: "We import sugar and sell to various organizations in the country",
  },

  {
    id: 6,
    img: product_img6,
    title: "COOKING OIL",
    desc: "We import oil from Asia and Europe and supply to local organizations (including red/palm oil)",
  },
  {
    id: 5,
    img: product_img5,
    title: "DENYA WOODS",
    desc: "We get it from our forest and sell it to various organizations",
  },
  {
    id: 7,
    img: product_img7,
    title: "AZOBE WOODS",
    desc: "We get it from our forest and sell it to various organizations",
  },
  {
    id: 8,
    img: product_img8,
    title: "TEAK",
    desc: "We get it from our forest and sell it to various organizations",
  },
  {
    id: 10,
    img: product_img10,
    title: "GOLD AND DIAMONDS",
    desc: "We are into minning and purchase of gold and rough diamonds",
  },
  {
    id: 9,
    img: product_img9,
    title: "SCRAPS",
    desc: "We are also into sale and purchase of scraps",
  },
];

export const member_of_img = member_of;

export const product_page_img = category_img4;

export const cart_img1 = product_img6;

export const cart_img2 = product_img1;

// TRAVEL AND TOUR SLIDERS
export const travelSliderImages = [
  {
    img: airplane,
    alt: "airplane",
    main_msg: "Travel At Ease With Sky And Sons Travel And Tour",
    sub_msg:
      "We aim  to provide a seamless and stress free travel experience for our clients",
  },
  {
    img: zanzibar,
    alt: "zanzibar",
    main_msg: "We Help People Make Memories",
    sub_msg:
      "Sky and Sons Travel And Tour is one of the leading tour operators in the Ghana.",
  },
  {
    img: kid_passport,
    alt: "kid_passport",
    main_msg: "We Assist Our Customers To Acquire Their Visas and Permits",
    sub_msg: "Work Permit, Study Permit, Students Visas ",
  },
  {
    img: lady_visa,
    alt: "lady_visa",
    main_msg: "We Offer Comprehensive Travel and Visa Processing Services",
    sub_msg:
      "With a dedicated team we are poised to revolutionize the travel and visa processing industry in Ghana. ",
  },
  // {
  //   img: polynesia,
  //   alt: "polynesia",
  // },
  // {
  //   img: bora_bora,
  //   alt: "bora_bora",
  // },
];

export const cartoon_tree = cartoon_tree_no_bg;
export const smiley_dark_lady = smile_black_lady;
export const traveling_white_lady = white_traveling_lady;

export const photos = [
  {
    src: "https://source.unsplash.com/2ShvY8Lf6l0/800x599",
    text: "Image One",
  },
  {
    src: "https://source.unsplash.com/Dm-qxdynoEc/800x799",
    text: "Image Two",
  },
  {
    src: "https://source.unsplash.com/qDkso9nvCg0/600x799",
    text: "Image Three",
  },
  {
    src: "https://source.unsplash.com/iecJiKe_RNg/600x799",
    text: "Image Four",
  },
  {
    src: "https://source.unsplash.com/epcsn8Ed8kY/600x799",
    text: "Image Five",
  },
  {
    src: "https://source.unsplash.com/NQSWvyVRIJk/800x599",
    text: "Image Six",
  },
  {
    src: "https://source.unsplash.com/zh7GEuORbUw/600x799",
    text: "Image Seven",
  },
  {
    src: "https://source.unsplash.com/PpOHJezOalU/800x599",
    text: "Image Eight",
  },
  {
    src: "https://source.unsplash.com/I1ASdgphUH4/800x599",
    text: "Image Nine",
  },
];

// export const Media = [
//   { type: "video", url: require("./images/media/vid-01.mp4") },
//   { type: "video", url: require("./images/media/vid-02.mp4") },
//   { type: "video", url: require("./images/media/vid-03.mp4") },
//   { type: "video", url: require("./images/media/vid-04.mp4") },
//   { type: "video", url: require("./images/media/vid-05.mp4") },
//   { type: "video", url: require("./images/media/vid-06.mp4") },
//   { type: "video", url: require("./images/media/vid-07.mp4") },
//   { type: "video", url: require("./images/media/vid-08.mp4") },
//   { type: "video", url: require("./images/media/vid-09.mp4") },
//   { type: "image", url: require("./images/media/img-01.jpg") },
//   { type: "image", url: require("./images/media/img-02.jpg") },
//   { type: "image", url: require("./images/media/img-03.jpg") },
//   { type: "image", url: require("./images/media/img-04.jpg") },
//   { type: "image", url: require("./images/media/img-05.jpg") },
// ];

export const media = [
  { id: 1, type: "video", src: gallery_video_1 },
  { id: 2, type: "video", src: gallery_video_2 },
  { id: 3, type: "image", src: gallery_image_1 },
  { id: 4, type: "image", src: gallery_image_2 },
  { id: 5, type: "image", src: gallery_image_3 },
  { id: 6, type: "image", src: gallery_image_4 },
  { id: 7, type: "video", src: gallery_video_3 },
  { id: 8, type: "video", src: gallery_video_4 },
  { id: 9, type: "video", src: gallery_video_5 },
  { id: 10, type: "video", src: gallery_video_6 },
  { id: 11, type: "image", src: gallery_image_5 },
  { id: 12, type: "video", src: gallery_video_7 },
  { id: 13, type: "video", src: gallery_video_8 },
  { id: 14, type: "video", src: gallery_video_9 },
];
